import { ProfilesService } from "../../services/profiles/service";
import { KDProfileCreateData } from "../../domain/kdiagram/profiles/data";
import { kdProfileDataFromJson } from "../../domain/kdiagram/profiles/mapper";
import { kdProfileCreateDataToJson, kdProfileDataToJson } from "../../domain/kdiagram/profiles/mapper_to_json";

const profilesService = new ProfilesService(
  localStorage.getItem("basicUrl"),
  kdProfileDataFromJson,
  kdProfileCreateDataToJson,
  kdProfileDataToJson
);

const getDefaultState = () => {
  return {
    createProfileData: KDProfileCreateData.defaultData(),
    addLoading: false,
    addError: null,
    addSuccess: null,
    addFailed: null,
  };
};

const state = getDefaultState();

const getters = {
  addRequestFailed: (state) => (state.addError !== null),
};

const actions = {
  async addProfile({ commit }, data) {
    commit("SET_ADD_LOADING_STATE");

    try {
      const profiles = await profilesService.createOne(
        localStorage.getItem("quad_token"),
        data.vesselName,
        data.createProfileData
      );
      commit("kDiagram/profiles/SET_UPDATE_PROFILES_STATE", profiles, { root: true });
      commit("SET_ADD_SUCCESS_STATE");
    } catch (error) {
      commit("SET_ADD_FAILED_STATE", error);
    }
  },

};

const mutations = {
  SET_ADD_LOADING_STATE: (state) => {
    state.addLoading = true;
    state.addError = null;
    state.addSuccess = null;
    state.addFailed = null;
  },
  SET_ADD_FAILED_STATE: (state, error) => {
    state.addLoading = false;
    state.addError = error;
    state.addSuccess = null;
    state.addFailed = true;
  },
  SET_ADD_SUCCESS_STATE: (state) => {
    state.addLoading = false;
    state.addSuccess = true;
    state.addFailed = null;
  },
  SET_CREATE_PROFILE_DATA_ATTRIBUTE: (state, data) => {
    state.createProfileData[data.attribute] = data.value;
  },
  RESTORE_REQUEST_STATE: (state) => {
    state.addSuccess = null;
    state.addFailed = null;
  }
};

export const kdiagramAddProfileModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
